import { UserEnums } from '@project44-models/iam-gateway';

import { IUserCreationForm } from '../../../interfaces';
import { UserCreationFormTemplate } from '../UserCreationFormTemplate';

export class TenantAdminUserCreatorTemplate extends UserCreationFormTemplate {
  public availableUserTypes = undefined;

  public transformUserCreationForm(
    userCreationForm: IUserCreationForm,
  ): IUserCreationForm {
    return {
      ...userCreationForm,
      userType:
        userCreationForm.userType === 'true'
          ? UserEnums.UserTypeEnum.CONTACT_PERSON
          : UserEnums.UserTypeEnum.USER,
    };
  }

  public static create = (): UserCreationFormTemplate => {
    return new TenantAdminUserCreatorTemplate();
  };
}
